import { Card, Heading } from '@etg/wings';
import { css } from '@eti/styles';
import { CABIN_UPGRADE } from '../../../products';
import CabinUpgradeAvailabilityStatus from '../CabinUpgradeAvailabilityStatus';
import { OriginDestinationText } from '../OriginDestinationText';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const unavailableSegmentHeadingStyle = css`
  margin-bottom: 8px;
`;
const CabinUpgradeUnavailableSegmentCard = ({
  availabilityCardTexts,
  flightRoute,
  originDestinationAirportAriaLabelText,
  segmentKey
}) => /*#__PURE__*/_jsxs(Card, {
  "data-testid": `${CABIN_UPGRADE.name}-selection-card-unavailable-${segmentKey}`,
  children: [/*#__PURE__*/_jsx(Heading, {
    "aria-label": originDestinationAirportAriaLabelText,
    className: unavailableSegmentHeadingStyle,
    "data-testid": `${CABIN_UPGRADE.name}-origin-destination-heading-${segmentKey}`,
    level: 3,
    children: /*#__PURE__*/_jsx(OriginDestinationText, {
      flightRoute: flightRoute
    })
  }), /*#__PURE__*/_jsx(CabinUpgradeAvailabilityStatus, {
    availabilityCardTexts: availabilityCardTexts,
    "data-testid": `${CABIN_UPGRADE.name}-availability-status-${segmentKey}`,
    isSegmentAvailable: false,
    originDestinationAirportAriaLabelText: originDestinationAirportAriaLabelText
  })]
}, segmentKey);
export default CabinUpgradeUnavailableSegmentCard;
//# sourceMappingURL=CabinUpgradeUnavailableSegmentCard.js.map